/* tslint:disable */
/* eslint-disable */
/**
 * Internal Variable Definitions Administration API
 *  ## Introduction  Variable Definitions are centralized definitions of concrete variables which are typically present in multiple datasets. Variable Definitions support standardization of data and metadata and facilitate sharing and joining of data by clarifying when variables have an identical definition.  ## Maintenance of Variable Definitions This API allows for creation, maintenance and access of Variable Definitions.  ### Ownership Creation and maintenance of variables may only be performed by Statistics Norway employees representing a specific Dapla team, who are defined as the owners of a given Variable Definition. In order to create variables, the single team an owner currently represents must be specified in the bearer token. This is currently only supported from the Dapla Lab platform. All maintenance is to be performed by the owners, with no intervention from administrators.  ### Status All Variable Definitions have an associated status. The possible values for status are `DRAFT`, `PUBLISHED_INTERNAL` and `PUBLISHED_EXTERNAL`.  #### Draft When a Variable Definition is created it is assigned the status `DRAFT`. Under this status the Variable Definition is:  - Only visible to Statistics Norway employees. - Mutable (it may be changed directly without need for versioning). - Not suitable to refer to from other systems.  This status may be changed to `PUBLISHED_INTERNAL` or `PUBLISHED_EXTERNAL` with a direct update.  #### Published Internal Under this status the Variable Definition is:  - Only visible to Statistics Norway employees. - Immutable (all changes are versioned). - Suitable to refer to in internal systems for statistics production. - Not suitable to refer to for external use (for example in Statistikkbanken).  This status may be changed to `PUBLISHED_EXTERNAL` by creating a Patch version.  #### Published External Under this status the Variable Definition is:  - Visible to the general public. - Immutable (all changes are versioned). - Suitable to refer to from any system.  This status may not be changed as it would break immutability. If a Variable Definition is no longer relevant then its period of validity should be ended by specifying a `valid_until` date in a Patch version.  ### Immutability Variable Definitions are immutable. This means that any changes must be performed in a strict versioning system. Consumers can avoid being exposed to breaking changes by specifying a `date_of_validity` when they request a Variable Definition.  #### Patches Patches are for changes which do not affect the fundamental meaning of the Variable Definition.  #### Validity Periods Validity Periods are versions with a period defined by a `valid_from` date and optionally a `valid_until` date. If the fundamental meaning of a Variable Definition is to be changed, it should be done by creating a new Validity Period.  
 *
 * The version of the OpenAPI document: 0.1
 * Contact: metadata@ssb.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CompleteView } from './CompleteView';
import {
    instanceOfCompleteView,
    CompleteViewFromJSON,
    CompleteViewFromJSONTyped,
    CompleteViewToJSON,
} from './CompleteView';
import type { RenderedView } from './RenderedView';
import {
    instanceOfRenderedView,
    RenderedViewFromJSON,
    RenderedViewFromJSONTyped,
    RenderedViewToJSON,
} from './RenderedView';

/**
 * @type ListVariableDefinitions200ResponseInner
 * 
 * @export
 */
export type ListVariableDefinitions200ResponseInner = CompleteView | RenderedView;

export function ListVariableDefinitions200ResponseInnerFromJSON(json: any): ListVariableDefinitions200ResponseInner {
    return ListVariableDefinitions200ResponseInnerFromJSONTyped(json, false);
}

export function ListVariableDefinitions200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListVariableDefinitions200ResponseInner {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfCompleteView(json)) {
        return CompleteViewFromJSONTyped(json, true);
    }
    if (instanceOfRenderedView(json)) {
        return RenderedViewFromJSONTyped(json, true);
    }
    return {} as any;
}

export function ListVariableDefinitions200ResponseInnerToJSON(json: any): any {
    return ListVariableDefinitions200ResponseInnerToJSONTyped(json, false);
}

export function ListVariableDefinitions200ResponseInnerToJSONTyped(value?: ListVariableDefinitions200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfCompleteView(value)) {
        return CompleteViewToJSON(value as CompleteView);
    }
    if (instanceOfRenderedView(value)) {
        return RenderedViewToJSON(value as RenderedView);
    }
    return {};
}

